import { useQuery } from '@zg-rentals/react-query5';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';
import { getClient } from '@zg-rentals/ts-rental-manager-api-client';

type QueryOptions = {
  onSuccess?: (response: unknown) => void;
  onError?: (err: unknown) => void;
  enabled?: boolean;
};

type HostedAppVersion = {
  version: string;
  branch: boolean;
};

const MAX_BUILD_INCREMENT_LIMIT = 10;
const CURRENT_BUILD_NUMBER = Number(process.env.BUILD_NUMBER);

const useBuildNumber = (queryOptions: QueryOptions = {}) => {
  const queryFn = () =>
    httpApiRequest<{ appName: string }, never, HostedAppVersion>(
      {
        getParams: { appName: 'zillow-rental-manager-web-next' },
        endpoint: '/hostedApp/version',
        method: 'GET',
        contextPath: '/rental-manager-api',
        unwrapApiLayerResponse: false,
      },
      getClient(),
    );

  const queryHook = useQuery({
    queryKey: ['useBuildNumber'],
    queryFn: async () => {
      try {
        const data = await queryFn();
        queryOptions.onSuccess?.(data);

        const buildNumber = Number(data.version);

        if (
          !data.branch &&
          !Number.isNaN(buildNumber) &&
          CURRENT_BUILD_NUMBER + MAX_BUILD_INCREMENT_LIMIT < buildNumber
        ) {
          window.location.reload();
        }

        return data;
      } catch (err) {
        queryOptions.onError?.(err);
        throw err;
      }
    },
    ...queryOptions,
    refetchOnWindowFocus: true,
    staleTime: 60 * 60 * 1000, // 1 hr
    retry: 1,
  });

  return queryHook;
};

export { useBuildNumber };
